import { useEffect } from "react";
import { useHistory } from "react-router";

import { PageLoader } from "src/components/page/loading/PageLoader";
import { usePermissions } from "src/hooks";
import { isEnabled } from "src/utils/permission.utils";

export function LoginRedirectPage() {
  const history = useHistory();
  const { data: permissions } = usePermissions();

  useEffect(() => {
    if (!permissions) return;

    // check user admin permissions
    if (isEnabled(permissions?.users.userAdmin)) history.push("/users");
    else history.push("/cases");
  }, [history, permissions]);

  // render the component
  return render();

  function render() {
    return <PageLoader />;
  }
}
